import { DBConnectorService } from './test.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { sectors, models } from './sector.model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoggedInGuard } from '../authentication/logged-in.guard';
@Injectable()
export class TrainService {

  constructor(private http: HttpClient,
    private dbConnectorService: DBConnectorService,
    private loggedInGuard: LoggedInGuard) {
  }

  statusCheck(Data) {
    const url = '/api/TrainExisting/TrainStatus';
    return this.http.post<any>(url, Data)
  }

  Step2(Data) {
    const url = '/api/TrainExisting/Step2';
    return this.http.post<any>(url, Data) // add the json file
  }

  Step2New(Data) {
    const url = '/api/TrainNew/Step2New';
    return this.http.post<any>(url, Data) // add the json file
  }

  getLabelName(data) {
    const url = '/api/TrainNew/GetLabelNames';
    return this.http.post<any>(url, data) // add the json file
  }

  getLabelMapping(data) {
    const url = '/api/TrainNew/GetLabelMapping';
    return this.http.post<any>(url, data) // add the json file
  }

  LabelMapping(data) {
    const url = '/api/TrainNew/LabelMapping';
    return this.http.post<any>(url, data) // add the json file
  }

  PreprocessExisting(data) {
    const url = '/api/TrainExisting/Preprocess';
    if (this.loggedInGuard.isSessionValid()) {
      return this.http.post<any>(url, data) // add the json file
    }
  }

  PreprocessNew(data) {
    const url = '/api/TrainNew/PreprocessNewData';
    if (this.loggedInGuard.isSessionValid()) {
      return this.http.post<any>(url, data) // add the json file
    }
  }

  TrainExisting(data) {
    const url = '/api/TrainExisting/trainFiles';
    return this.http.post<any>(url, data) // add the json file
  }

  TrainNew(data) {
    const url = '/api/TrainNew/trainFilesNewData';
    if (this.loggedInGuard.isSessionValid()) {
      return this.http.post<any>(url, data) // add the json file
    }
  }

  cancelTrain(Data) {
    const url = '/api/TrainExisting/CancelTrain';
    return this.http.post<any>(url, Data) // add the json file
  }

  trainwithxls(data) {
    const url = '/api/TrainExisting/Step2';
    if (this.loggedInGuard.isSessionValid()) {
      return this.http.post<any>(url, data)
    }
  }

  IsLabelMappingTrainExisting(Data) {
    const url = '/api/TrainExisting/IsLabelMapping';
    return this.http.post<any>(url, Data) // add the json file
  }
}
